import React, { cloneElement, isValidElement } from 'react';
import styles from '../styles.module.css';
import { featCard } from '@/commonTypes';

export default function FeatCard({
  f,
  fill = '#fff',
  iconSize = '24px',
  bg = 'white',
  showNumber = false,
  index,
  className = '',
  headTag,
  iconClassName = '',
  titleClass = '',
  textClass = '',
  movingCard = true,
}: {
  f?: featCard;
  fill?: string;
  iconSize?: string;
  bg?: 'white' | 'lightGray';
  showNumber?: boolean;
  index: number;
  className?: string;
  headTag?: 'h2' | 'h3';
  iconClassName?: string;
  titleClass?: string;
  textClass?: string;
  movingCard?: boolean;
}) {
  const Head = headTag ? headTag : 'h3';
  return (
    <div
      className={`${styles.card} ${bg == 'lightGray' && styles.light} ${movingCard && 'movingCard'} ${className}`}
    >
      <div className={`${styles.titleWrapper}`}>
        <div
          className={`${styles.icon} ${iconClassName}`}
          style={{ background: f?.bg, boxShadow: f?.glow ? `0 10px 24px ${f?.glow}` : 'unset' }}
        >
          {isValidElement(f?.icon)
            ? cloneElement(f?.icon, {
                fill: fill,
                width: `${iconSize}`,
                height: `${iconSize}`,
              })
            : f?.icon}
        </div>
        {showNumber && <span className={`${styles.number}`}>{index + 1}</span>}
      </div>

      <Head className={`${styles.cardTitle} ${titleClass}`}>{f?.t}</Head>

      <p className={`${styles.cardDesc} ${textClass}`}>{f?.d}</p>
    </div>
  );
}
